<script>
    export default {
      name: 'lote-imagens',
      props: ['lote', 'video'],
      data () {
        return {
          loteAtual: null,
          url: null,
          imagem: null,
          imagemIndex: 0,
          imagens: [],
          videoAtivo: false
        }
      },
      watch: {
        lote () {
          this.montaAnimacao()
        },
        video () {
          if (this.video !== null) {
            this.videoAtivo = true
            this.playVideo()
          } else {
            this.videoAtivo = false
          }
        }
      },
      mounted () {
      },
      destroyed () {
      },
      methods: {
        montaAnimacao () {
          let lote = this.lote
          this.videoAtivo = false
          if (this.loteAtual === lote.id) {
            return
          }
          let url = lote.imagem.split('/')
          url.splice(-1, 1)
          url = url.join('/') + '/'
          this.url = url
          this.imagens = []
          lote.fotos.forEach((foto) => {
            // this.imagens.push(url + foto.id + '.jpg')
            this.imagens.push(foto.url)
          })
          this.imagem = this.imagens[0]
          window.clearInterval(this.$interval)
          this.$interval = setInterval(() => {
            this.imagemIndex++
            if (typeof this.imagens[this.imagemIndex] === 'undefined') {
              this.imagemIndex = 0
              if (this.video !== null) {
                this.videoAtivo = true
              }
            }
            this.imagem = this.imagens[this.imagemIndex]
          }, 2000)
        },
        onEnd: function () {
          this.videoAtivo = false
          this.imagemIndex = 0
          this.montaAnimacao()
          // this.$emit('videoEnded')
        },
        playVideo () {
          if (!this.videoAtivo) return
          window.setTimeout(() => {
            let videoFrame = document.getElementById('loteVideo')
            if (videoFrame.paused || videoFrame.ended) {
              videoFrame.play()
            }
          }, 200)
        }
      },
      components: {}
    }
</script>

<template>
  <div class="image" :class="'lote-img-status' + lote.status">
    <video id="loteVideo" @ended="onEnd" v-if="videoAtivo" autoplay>
      <source :src="video" type="video/mp4">
    </video>
    <img :class="videoAtivo ? 'hide' : ''" ref="imagem" :src="imagem">
  </div>
</template>



// WEBPACK FOOTER //
// lote-imagens.vue?6cb58884